<div nz-row [ngClass]="'home-second-header'">
  
  <div class="upload-container">

    <div nz-col class="upload">
      <nz-spin [nzSpinning]="loadingPage">
        <ng-container *ngIf="userCredit > 0 || unlimitedSubscription">
          <nz-spin [nzSpinning]="isSpinning">
            <div class="upload-area">
              <button class="evolution-button" appDnd (fileDropped)="onFileDropped($event)">
                <input type="file" (change)="fileBrowseHandler($event.target.files)" />
                <p>ÎNCARCĂ BALANȚA</p>
                <span class="button-custom-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#FFFFFF">
                    <path
                      d="M445-80q-29 0-56-12t-45-35L127-403l21-23q14-15 34.5-18.5T221-438l99 53v-365q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v465l-144-77 156 198q10 12 23.76 18 13.76 6 29.24 6h205q38 0 64-26t26-64v-170q0-25.5-17.25-42.75T680-460H460v-60h219.65q50.14 0 85.25 35 35.1 35 35.1 85v170q0 63-43.5 106.5T650-80H445ZM203-665q-11.07-18.75-17.04-40.49-5.96-21.74-5.96-44.76 0-70.75 49.73-120.25Q279.45-920 350-920t120.27 49.74Q520-820.52 520-749.96q0 22.96-5.96 44.62Q508.07-683.68 497-665l-52-30q7-12 11-26t4-29.48Q460-796 427.88-828q-32.12-32-78-32T272-827.92q-32 32.09-32 77.92 0 15 4 29t11 26l-52 30Zm285 335Z"
                    />
                  </svg>
                </span>
              </button>
              
              <h3 class="c-black">Balanța sintetică în format Excel</h3>
              <h2 class="hand-write p-2">
                Analiza afacerii în
                <span class="circle">5</span>
                secunde
              </h2>

              <nz-progress [nzPercent]="progress" nzType="circle" *ngIf="progress"></nz-progress>
              
              <!-- Error alerts moved here for better mobile positioning -->
              <nz-alert nzType="error" nzMessage="Error" *ngIf="fileTypeError == 1" nzDescription="Vă rugăm să încărcați o balanță în format Excel!" nzShowIcon></nz-alert>
              
              <nz-alert nzType="error" nzMessage="Error" *ngIf="error == 1" [nzDescription]="descriptionTpl" nzShowIcon>
                <ng-template #descriptionTpl><span innerHTML="{{ alertTxt }}"></span></ng-template>
              </nz-alert>
            </div>

            <nz-modal [(nzVisible)]="isVisibleModal" nzTitle="Selectează luna și anul balanței" (nzOnCancel)="handleCancel()">
              <div *nzModalContent>
                <nz-calendar class="custom-pagination" [nzFullscreen]="false" (nzSelectChange)="onValueChange($event)" (nzPanelChange)="onPanelChange($event)" nzMode="year"></nz-calendar>
              </div>
              <div *nzModalFooter>
                <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isConfirmLoading">Ok, procesează balanța</button>
              </div>
            </nz-modal>
          </nz-spin>
        </ng-container>
      </nz-spin>
    </div>

    <div nz-col class="home-right">
      <img src="/assets/img/puzzle.png" *ngIf="userCredit != 0 || unlimitedSubscription" />
      <img src="/assets/img/NETOPIA.png" class="netopia" *ngIf="userCredit == 0 && !unlimitedSubscription" />
    </div>

  </div>

  <!-- SVG decorativ - ascuns pe mobil prin CSS -->
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 239" id="bg-shape-black-small">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path d="M0,241V140.62s385.16,99.61,889.34-39.8S1920,7.19,1920,7.19V241"></path>
      </g>
    </g>
  </svg>
</div>
